class ConsoleCommandsLines {

}

export default new ConsoleCommandsLines();